import React from "react";
import ComicBase from "../ComicBase";

export default function ComicKimetsu() {
  return (
    <ComicBase
      titulo="DEADPOOL and CHUN LI [Sorje]"
      portada="https://i.ibb.co/fVgkv05Q/deadpool-and-chun-li-1.jpg"
      
      paginas={[
        "https://i.ibb.co/fVgkv05Q/deadpool-and-chun-li-1.jpg",
        "https://i.ibb.co/MkZscQGM/deadpool-and-chun-li-2.jpg",
        "https://i.ibb.co/RpysnwxT/deadpool-and-chun-li-3.jpg",
        "https://i.ibb.co/tTVQWRtN/deadpool-and-chun-li-4.jpg",
        "https://i.ibb.co/XZvXgPTg/deadpool-and-chun-li-5.jpg",
      ]}

      sugeridos={[
      
      ]}

      info={{
        grupo: "Video Juegos",
        tipo: "Sorje",
        idioma: "Español",
        serie: "Street Fighter",
    personajes: ["Chun li", "Dead pool"],
        etiquetas: ["Superheroes"],
        artistas: "",
      }}
    />
  );
}

export const infoManga = {
  titulo: "DEADPOOL and CHUN LI [Sorje]",
  portada: "https://i.ibb.co/fVgkv05Q/deadpool-and-chun-li-1.jpg",
  reverso: "https://i.ibb.co/MkZscQGM/deadpool-and-chun-li-2.jpg", // Primera página para el holograma trasero
   enlace: "/comic/DEADPOOL-and-CHUN-LI", // 👈 Añadí esta línea
         fecha:"2026-05-9", // 👈 MOVER AQUÍ

  info: {
     grupo: "Video Juegos",
        tipo: "Sorje",
        idioma: "Español",
        serie: "Street Fighter",
    personajes: ["Chun li", "Dead pool"],
        etiquetas: ["Superheroes"],
        artistas: "",
  },
};
